






import { Component, Vue, Prop } from "vue-property-decorator";

import productsInfoJson from "../../public/productsInfo/productsInfo.json";
import productsListJson from "../../public/productsInfo/productsList.json";
import piecesInfoJson from "../../public/productsInfo/piecesInfo.json";
import * as actions from "@/service/revolva.action";
import { RevolvaService } from "@/service/revolva.service";

interface Dictionary<T> {
  [Key: string]: T;
}

@Component({
  components: {},
})
export default class Model3D extends Vue {
  @Prop() readonly revolva: RevolvaService | undefined;

  public Canvafullscreen: false;
  public fullscreen: false;

  public canvasH = 0;
  public canvasW = 0;
  public offsetHeight = 40;
  public offsetWidth = 0;

  public loading3d = true;

  mounted() {
    this.Canvafullscreen = false;
    // this.canvasH =
    //   document.getElementById("fullscreen").offsetHeight - this.offsetHeight;
    // this.canvasW =
    //   document.getElementById("fullscreen").offsetWidth - this.offsetWidth;
    actions.setproductsListJson(this.revolva, productsListJson);
    actions.setProductsInfo(this.revolva, productsInfoJson);
    actions.setPiecesInfo(this.revolva, piecesInfoJson);
    actions.setCanvas(
      this.revolva,
      document.getElementById("canvas") as HTMLCanvasElement
    );
    actions.setCanvaSize(
      this.revolva,
      document.getElementById("model-container").offsetWidth,
      document.getElementById("model-container").offsetHeight
    );
    actions.setMainObjects(this.revolva);

    actions.init(this.revolva);
    this.loading3d = this.revolva.loading3D;
    actions.startLoad3d(this.revolva);
  }

  created() {
    window.addEventListener("resize", this.onWindowResize, false);
  }
  destroyed() {
    window.removeEventListener("resize", this.onWindowResize);
  }

  onWindowResize() {
    this.resize();

    setTimeout(() => {
      this.resize();
    }, 100);
  }

  public resize() {
    if (!this.revolva.canvaFullScreen) {
      actions.setCanvaSize(
        this.revolva,
        document.getElementById("model-container").offsetWidth,
        document.getElementById("model-container").offsetHeight
      );
    }
    actions.onWindowResize(this.revolva);
  }

  public start() {
    actions.startLoad3d(this.revolva);
  }

  public animate() {
    this.revolva.animation = !this.revolva.animation;
    actions.renderModel(this.revolva);
  }
}
